import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';

const SearchFilterValueDto = t.type(
  {
    id: t.string,
    name: nullable(t.string),
    code: nullable(t.string),
    color: nullable(t.string),
    order: nullable(t.number),
    defaultSelected: t.boolean,
  },
  'SearchFilterValueDto',
);

type SearchFilterValueDto = t.TypeOf<typeof SearchFilterValueDto>;
export { SearchFilterValueDto };
